<template>
    <b-container>
        <b-row>
            <b-col cols-sm="12" cols-md="6">
                <div  class="authentication-card">
                    <div class="center-content">
                        <h3>
                            Thanks for submitting your request
                        </h3>
                        <p>
                            Your account approval is pending. Please check your email for updates.
                        </p>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import MxSecurity from '@/mixins/security'
import Loading from '@/components/utility/loading.vue'

@Component({
  components: {
    Loading,
  },
})

export default class extends Mixins(MxSecurity) {
}
</script>
<style>
    @import '../../styles/authentication.css'
</style>
